/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
/* NPM Imports Start */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropsTypes from 'prop-types';
import Popup from 'devextreme-react/popup';

/* NPM Imports End */

/* Project Imports Start */
import { updatePasswordAction } from '../../store/action/userAction';
import {
  regularExpression,
  responseOkCode,
  twoThousand,
  n208,
  appVersion,
} from '../../constant';
/* Project Imports End */

/* CCS & Image imports Start */
import './ResetPassword.scss';
import logo from '../../assets/images/FieldPRO_Logo_Colour.svg';
import { ReactSVG } from 'react-svg';
import { ToasterMessage } from '../../components/sharedComponents';
/* CCS & Image imports End */

const ResetPassword = props => {
  const history = useHistory();
  const dispatch = useDispatch();
  const userDetails = useSelector(state => state);
  const [popup, setPopup] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isError, setIsError] = useState(false);
  const [errorMSG, setErrorMSG] = useState('');

  useEffect(() => {
    if (userDetails.user.resetSuccess === responseOkCode) {
      ToasterMessage('success', 'You have Updated password successfully');
      setTimeout(() => {
        history.push('/login');
      }, twoThousand);
    }
    if (userDetails.user.resetSuccess === n208) {
      ToasterMessage('error', 'Link has been expired.Please contact admin');
    }
  }, [userDetails]);
  const handlePassword = event => {
    setIsError(false);
    setErrorMSG('');
    setPassword(event.target.value);
  };
  const handleConfirmPassword = event => {
    setIsError(false);
    setErrorMSG('');
    setConfirmPassword(event.target.value);
  };
  const onSubmit = () => {
    if (validation()) {
      const data = {
        Usersuuid: props.match.params.userid,
        password,
      };
      dispatch(updatePasswordAction('Users/updatepassword', data));
    }
  };
  const validation = () => {
    setIsError(false);
    setErrorMSG('');
    const regex = regularExpression.Password;
    if (password === '' || confirmPassword === '') {
      setIsError(true);
      setErrorMSG('Password and confirm password cannot be empty');
      return false;
    }
    if (!password.match(regex) || !confirmPassword.match(regex)) {
      setIsError(true);
      setErrorMSG(
        'Password must be at least 8 characters, and include at least one numeric digit, one special character, one uppercase letter, and one lowercase letter.',
      );
      return false;
    }
    if (password !== confirmPassword) {
      setIsError(true);
      setErrorMSG('Password does not match');
      return false;
    }
    return true;
  };
  const handlePopup = () => {
    setPopup(false);
    history.push('/login');
  };
  const popupContent = () => (
    <div style={{ textAlign: 'center' }}>
      <button className="btn btn-success" onClick={handlePopup}>
        Ok
      </button>
    </div>
  );

  return (
    <div className="Wrapper">
      <Popup
        title="Password updated successfully"
        height={160}
        width={500}
        visible={popup}
        contentRender={popupContent}
        onHiding={handlePopup}></Popup>
      <div>
        <div className="ResetForm">
          <div className="logo">
            <ReactSVG style={{ height: '50px', width: '100%' }} src={logo} />
          </div>
          <div className="form">
            <div className="form-items">
              <strong>Enter Password</strong>
              <input
                type="password"
                id="password"
                name="password"
                className="form-control"
                autoComplete="off"
                value={password}
                onChange={handlePassword}
              />
            </div>
            <div className="form-items">
              <strong>Confirm Password</strong>
              <input
                type="password"
                id="confirm-password"
                name="confirm-password"
                className="form-control"
                autoComplete="off"
                value={confirmPassword}
                onChange={handleConfirmPassword}
              />
            </div>
            <div id="warning" className={isError ? 'warning' : 'hide'}>
              <span>
                {errorMSG}
                <i className="fa fa-warning"></i>
              </span>
            </div>
            <div className="form-items">
              <button className="reset-button" onClick={onSubmit}>
                Reset Password
              </button>
            </div>
          </div>
        </div>
        <div className="disclaimer-container">
          <p>
            ONYX Insight fieldPRO {appVersion} - © {new Date().getFullYear()}{' '}
            Insight Analytics Solutions Limited.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;

ResetPassword.displayName = 'ResetPassword';

/* PropsTypes Validation Start*/
ResetPassword.propTypes = {
  userid: PropsTypes.any,
  match: PropsTypes.any,
};
/* PropsTypes Validation End*/

/* DefaultProps */
ResetPassword.defaultProps = {};
/* DefaultProps */
